module.exports = __webpack_public_path__ + "static/img/home_h122px_web_icon_tap.036a20f.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/home_h122px_web_icon_tap.gif
// module id = IOzl
// module chunks = 0